class DeferredPromise {
  state = 'pending';
  promise;
  resolve;
  reject;

  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = () => {
        this.state = 'fullfilled';
        resolve();
      }
      this.reject = () => {
        this.state = 'rejected';
        reject();
      }
    });
  }
}

export default DeferredPromise;